import { DependencyList, useContext, useEffect } from 'react';

import { WindowSizeContext } from 'contexts';
import { useAdSessionManager } from 'hooks';

export type AdPageType = 'ros' | 'home' | 'profile' | 'search' | 'groups' | 'chat';

// Set the ad framework mapping (ad units for given page type)
//
// This should generally be loaded once per page, but some pages
// e.g. user profile, groups will need to pass in dependencies to reload
// ads when the page content changes but the calling component does not unmount.
const useLoadMapping = (pageType?: AdPageType, deps?: DependencyList): void => {
    const { isMobile } = useContext(WindowSizeContext);

    const { currentAdProvider, incrPageViewCount } = useAdSessionManager();

    useEffect(() => {
        console.info('ads: incr-view');
        incrPageViewCount();

        if (currentAdProvider !== 'pubstream') return;

        console.info('ads: load-mapping');
        // window.loadMapping(pageType, isMobile);
        window.reloadPubstream();
    }, [pageType, isMobile, ...(deps || [])]);
};

export default useLoadMapping;
